export enum CategoryType {
  MINGA_GROUP = 'MINGA_GROUP',
  POINT = 'POINT',
  FLEX_TIME = 'FLEX_TIME',
}
